import React, { useContext, useEffect, useState } from "react";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import {
  CommonDropdownData,
  getEmploymentDetailsByMemberId,
} from "../../../Helpers/APIEndPoints/EndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm from "../../../Components/InputForm/InputForm";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { useLocation } from "react-router-dom";
import notify from "../../../Helpers/ToastNotification";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";
import { useSelector } from "react-redux";
const EmployeeDetails = (props) => {
  const [companyOptions, setCompanyOptions] = useState([]);
  const [disable, setDisabled] = React.useState(false);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [unitcodeOptions, setUnitCodeOptions] = useState([]);
  const [error, setError] = React.useState<any>({});
  const { showLoader, hideLoader } = useContext(LoaderContext);
  // const memberid = GetDecryptedMemberIdFromLocalStorage() || "";
  // const { state } = useLocation();
  // const memberid = state.id ? state.id : "";
  // console.log(memberid, "memberid EmployeeDetails");
  const location = useLocation();
  const [data, setData] = useState({
    company: null,
    sector: null,
    designation: null,
    department: null,
    location: null,
    unitcode: null,
    salary: null,
    monthlySalary: null,
  });

  const isApplicantTypeOthers = useSelector(
    (state: any) => state?.MemberRegistrationReducer?.isApplicantTypeOthers
  );

  

  const [isOtherApplicantType, setIsOtherApplicantType] = useState(false);

  // useEffect(() => {
  //   if (isApplicantTypeOthersOld != isApplicantTypeOthers) {
  //     setIsApplicantTypeOthersOld(isApplicantTypeOthers);
  //     setData({ ...data, department: null, designation: null });
  //   }
  // }, [isApplicantTypeOthers]);

  useEffect(() => {
    sectoroptions();
    companyoptions();
    locationoptions();
    departmentdropdown();
    designationoptions();
    unitcodeoptions();
  }, []);
  const sectoroptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "sectordd",
    });
    if (resp?.Data?.length > 0) {
      setSectorOptions(resp?.Data);
    }
  };
  const companyoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "companydd",
    });
    if (resp?.Data?.length > 0) {
      setCompanyOptions(resp?.Data);
    }
  };
  
  const locationoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "locationdd",
    });
    if (resp?.Data?.length > 0) {
      setLocationOptions(resp?.Data);
    }
  };
  const departmentdropdown = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "departmentdd",
    });
    if (resp?.Data?.length > 0) {
      setDepartmentOptions(resp?.Data);
    }
  };
  const designationoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "designationdd",
    });
    if (resp?.Data?.length > 0) {
      setDesignationOptions(resp?.Data);
    }
  };
  const unitcodeoptions = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "unitcodedd",
    });
    if (resp?.Data?.length > 0) {
      setUnitCodeOptions(resp?.Data);
    }
  };
  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const getEmploymentDetailsByMemberIdApiCall = async (memberid: any) => {
    showLoader();

    // let param = `${getEmploymentDetailsByMemberId}/${id}`;

    // const res = await APICall(param, {}, HttpMethod.GET);

    let requestParams = { MemberId: memberid };
    const res = await APICall(getEmploymentDetailsByMemberId, requestParams);

    if (res.Message === "Ok" && res.Data !== null) {
      const isOtherApplicantType = res.Data.ApplicantType == 2;
      let data = {
        company: { label: res.Data.CompanyName, value: res.Data.CompanyId },
        sector: { label: res.Data.SectorName, value: res.Data.SectorId },
        designation: isOtherApplicantType
          ? res.Data.DesignationName
          : {
              label: res.Data.DesignationName,
              value: res.Data.DesignationId,
            },
        department: isOtherApplicantType
          ? res.Data.DepartmentName
          : {
              label: res.Data.DepartmentName,
              value: res.Data.DepartmentId,
            },
        location: { label: res.Data.LocationName, value: res.Data.LocationId },
        unitcode: { label: res.Data.UnitCodeName, value: res.Data.UnitCodeId },
        salary: Number(res.Data.Salary),
        monthlySalary: Number(res.Data.MonthlyPFBaseSalary),
      };
      setData(data);
      setIsOtherApplicantType(isOtherApplicantType);
      hideLoader();
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };
  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) {
        //|| params.has("hide")
        let encMemberId = params.get("memberid");
        // let memberid = decodeURIComponent(Decrypt(encMemberId));
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split("||");
        let memberid = parts[0];
        // let hide = params.get("hide");
        onLoadApiCall(memberid);
      }
    }
  }, [location.search]);
  const onLoadApiCall = async (memberid) => {
    showLoader();

    if (memberid != null && memberid != "") {
      await getEmploymentDetailsByMemberIdApiCall(memberid);
    } else {
      notify(1, "Something went wrong");
    }

    hideLoader();
  };

  // useEffect(() => {
  //   onLoadApiCall();
  // }, []);

  return (
    <>
      <div className="">
        <div className="col-lg-12 col-md-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Company</label>
              <sup>*</sup>
              <SelectForm
                value={data.company}
                isDisabled={true}
                placeholder="Select Company"
                options={companyOptions}
                onChange={(val: any) => onChange("company", val)}
              />
              {error[data.company] && (
                <p style={{ color: "red" }}>{error[data.company]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Sector</label>
              <sup>*</sup>
              <SelectForm
                value={data.sector}
                isDisabled={true}
                placeholder="Select Sector"
                options={sectorOptions}
                onChange={(val: any) => onChange("sector", val)}
              />
              {error[data.sector] && (
                <p style={{ color: "red" }}>{error[data.sector]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Location</label>
              <sup>*</sup>
              <SelectForm
                value={data.location}
                isDisabled={true}
                placeholder="Select Location"
                options={locationOptions}
                onChange={(val: any) => onChange("location", val)}
              />
              {error[data.location] && (
                <p style={{ color: "red" }}>{error[data.location]}</p>
              )}
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Department</label>
              <sup>*</sup>
              {!isOtherApplicantType ? (
                <SelectForm
                  value={data.department}
                  isDisabled={true}
                  placeholder="Select Department"
                  options={departmentOptions}
                  onChange={(val: any) => onChange("department", val)}
                />
              ) : (
                <InputForm
                  placeholder={""}
                  value={data.department}
                  onChange={(event: any) => {
                    onChange("department", event?.target?.value);
                  }}
                  type="text"
                  isDisabled={true}
                />
              )}
              {error[data.department] && (
                <p style={{ color: "red" }}>{error[data.department]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Designation</label>
              <sup>*</sup>
              {!isOtherApplicantType ? (
                <SelectForm
                  value={data.designation}
                  isDisabled={true}
                  placeholder="Select Designation"
                  options={designationOptions}
                  onChange={(val: any) => onChange("designation", val)}
                />
              ) : (
                <InputForm
                  placeholder={""}
                  value={data.designation}
                  onChange={(event: any) => {
                    onChange("designation", event?.target?.value);
                  }}
                  type="text"
                  isDisabled={true}
                />
              )}
              {error[data.designation] && (
                <p style={{ color: "red" }}>{error[data.designation]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Unit Code</label>
              <sup>*</sup>
              <SelectForm
                value={data.unitcode}
                isDisabled={true}
                placeholder="Select Unit Code"
                options={unitcodeOptions}
                onChange={(val: any) => onChange("designation", val)}
              />
              {error[data.designation] && (
                <p style={{ color: "red" }}>{error[data.designation]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Salary</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={data.salary}
                isDisabled={true}
                onChange={(val: any) => {
                  let value = val.target.value;
                  const regex = /^[0-9\b]/;
                  if (value === "" || regex.test(value)) {
                    if (value.length > 20) {
                      value = value.slice(0, 20);
                    }
                    onChange("salary", value);
                  }
                }}
                type="number"
                onWheel={(e) => e.target.blur()}
              />
              {error[data.salary] && (
                <p style={{ color: "red" }}>{error[data.salary]}</p>
              )}
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Monthly PF Base Salary</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={data.monthlySalary}
                isDisabled={true}
                onChange={(val: any) => {
                  let value = val.target.value;
                  const regex = /^[0-9\b]/;
                  if (value === "" || regex.test(value)) {
                    if (value.length > 20) {
                      value = value.slice(0, 20);
                    }
                    onChange("monthlysalary", value);
                  }
                }}
                type="number"
                onWheel={(e) => e.target.blur()}
              />
              {error[data.monthlySalary] && (
                <p style={{ color: "red" }}>{error[data.monthlySalary]}</p>
              )}
            </div>
            {/* <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="" style={{marginTop:"30px"}}>
              <input
                autoComplete={AutoCompleteValue}
                placeholder={""}
                value={""}
                
                onChange={(val: any) => {
                  let value = val.target.value;
                  onChange("terms", value);
                }}
                type="checkbox"
              />   <span  style={{marginLeft:"12px"}}>Check on the checkbox if you have submitted member enrollment from offline</span>
              </div>
            </div> */}
          </div>
          {/* <div
            className="p-2 d-flex justify-content-end"
            style={{ marginTop: 50 }}
          >
          
               <ButtonComponent  icon={"fas fa-arrow-left"} value={"Back" }  onClick={selectPreviousTab} />
               <ButtonComponent  icon={"fas fa-arrow-right"} value={"Save & Next" } style={{marginLeft:"10px"}}  id={"saveBtn"} onClick={onSubmit}/>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default EmployeeDetails;
